import React from 'react';

// Official Reflections by Rowdy logo — the mindful nature emblem with the
// tree, Rowdy's profile, and roots. Served from /public/brand so it's
// bundled with the app and available offline / after PWA install.
const LOGO_URL = '/brand/rbr-logo.png';

const Logo = ({ size = 44, className = '' }) => {
  return (
    <img
      src={LOGO_URL}
      alt="Reflections by Rowdy"
      width={size}
      height={size}
      className={`object-cover ${className}`}
      style={{ width: size, height: size, borderRadius: '50%' }}
    />
  );
};

export default Logo;
